<footer class="footer">
	<section>
		<section class="footer__header">
			<img
				class="footer__logo"
				src="./assets/images/general/logo.png"
				alt="logo de cmv finanzas"
				href="https://www.cajamorelia.com.mx/"
				onclick="abrirCMV()" />
			<h2 class="footer__header-title">
				#Somos<span>LaCaja</span>QueVaContigo
			</h2>
		</section>
		<section class="footer__contact">
			<h2 class="footer__contact-title">Contacto</h2>
			<p>
				Tel. 800 3000 268
				<br />atencionasocios@cajamorelia.com.mx <br />Acatita de Baján 222,
				Morelia, Mich.
			</p>
		</section>
	</section>
	<cmv-social-media
		class="footer__social-media"
		color="#84bd00"></cmv-social-media>
	<div class="footer__info">
		<p class="footer__message">
			Caja Morelia Valladolid S.C. de A.P. de R.L. de C.V.
		</p>
		<span class="footer__version">v{{ version }}</span>
	</div>
</footer>
